import { render } from "./Plasmid.vue?vue&type=template&id=24707a50&scoped=true"
import script from "./Plasmid.vue?vue&type=script&lang=js"
export * from "./Plasmid.vue?vue&type=script&lang=js"

import "./Plasmid.vue?vue&type=style&index=0&id=24707a50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24707a50"]])

export default __exports__